import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaTools,
  FaShoppingCart,
  FaRocket,
  FaShieldAlt,
  FaMobileAlt,
  FaStar,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const SmallBusinessEcommerceWebsitesInDubai = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Small Business E-commerce Websites in Dubai" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Grow Easy</Subheading>}
        heading={
          <Heading>
            Small Business{" "}
            <span tw="text-primary-500">E-commerce Websites</span> in Dubai
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we specialize in small business e-commerce
            websites in **Dubai**, offering affordable, user-friendly online
            stores tailored to help your business thrive. Start selling online
            with confidence.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Small business owner with laptop
          "https://images.unsplash.com/photo-1506784983877-45594efa4cbe?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Small shop with products
          "https://images.unsplash.com/photo-1472851294608-062f824d29cc?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Local business success
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Launch Your Store Now"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="E-commerce Made Simple for Small Businesses"
        description="We empower small businesses in Dubai with the right tools."
        cards={[
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Affordable Solutions",
            description: "Cost-effective stores for small budgets.",
          },
          {
            icon: <FaTools color="#ff5464" size={40} />,
            title: "Easy Customization",
            description: "Tailored designs to fit your brand.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Quick Setup",
            description: "Get online fast with minimal hassle.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Mobile-Friendly",
            description: "Reach customers on any device.",
          },
          {
            icon: <FaShieldAlt color="#ff5464" size={40} />,
            title: "Secure Payments",
            description: "Safe transactions for you and your buyers.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Trusted Support",
            description: "Dubai’s go-to for small business e-commerce.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Small Business E-commerce Process"
        description={
          <Description>
            We build your online store with simplicity and care:
            <ul tw="mt-4 list-disc pl-6">
              <li>Consultation: Understand your business and goals.</li>
              <li>Design: Create a simple, effective store layout.</li>
              <li>Development: Build essential e-commerce features.</li>
              <li>Integration: Add payments and shipping options.</li>
              <li>Launch: Get your store live quickly and easily.</li>
              <li>Support: Provide ongoing help as you grow.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Small team planning
          "https://images.unsplash.com/photo-1533750349088-cd871a92f312?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Person working on laptop with coffee
          "https://images.unsplash.com/photo-1556740772-1a741367b93e?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Mobile shopping experience
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="Small Business Wins in Dubai"
        description="Our stores help small businesses succeed."
        cards={[
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Sales Boost",
            description: "Doubled revenue for a local shop in 3 months.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Fast Launch",
            description: "Store live in just 10 days for a startup.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Happy Clients",
            description: "96% satisfaction from small businesses.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready to Sell Online?</Subheading>}
        heading="Small Business E-commerce Websites in Dubai"
        description={
          <Description>
            Partner with MilaajBrandset for small business e-commerce websites
            in Dubai. Get an affordable, powerful online store to grow your
            business—contact us today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Small business in Dubai
          "https://images.unsplash.com/photo-1591085686350-798c0f9faa7f?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Person managing online store
          "https://images.unsplash.com/photo-1539189017439-52ea067284a3?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Small shop inventory
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
